import Model from "../Model";

class BubblesGestnoGestDetail extends Model{

    buildUrl ({ param }) {
        return ['industrialgroupview/details', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new BubblesGestnoGestDetail;